export const MuiFormControl = {
  styleOverrides: {
    marginNormal: {},
  },
};
